export default __webpack_public_path__ + "static/media/ron-rambell-logo.f5e658a2.png";